import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC, useState } from 'react';

import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { PaymentType } from '../../types';

const paymentTypes = [PaymentType.CARD, PaymentType.CRYPTO] as const;

export const PaymentTypeSelector: FC = () => {
  const { t } = useTranslation(['product', 'countries']);
  const drawController = usePreAuthDrawCtx();
  const [emitter] = useAnalyticsEmitter();
  const { goToStep } = useFlow();

  const [selectedPaymentType, setSelectedPaymentType] =
    useState<PaymentType | null>(drawController.selectedPaymentType);

  return (
    <div className="flex flex-col space-y-6">
      <CheckboxWrapper>
        {paymentTypes.map((type) => (
          <CheckboxCard
            key={`payment-type-${type}`}
            checked={selectedPaymentType === type}
            description={t(
              `drawers.review.draw.paymentMethod.selectPaymentType.${type}.details`,
            )}
            id={`payment-type-${type}`}
            label={t(
              `drawers.review.draw.paymentMethod.selectPaymentType.${type}.title`,
            )}
            name={`payment-type-${type}`}
            onChange={() => setSelectedPaymentType(type)}
            type="radio"
            value={`payment-type-${type}`}
          />
        ))}
      </CheckboxWrapper>

      <Button
        disabled={!selectedPaymentType}
        fullWidth
        label={t(
          'drawers.review.draw.paymentMethod.selectPaymentType.continueButton',
        )}
        onClick={() => {
          emitter(`${selectedPaymentType} option`, 'clicked');
          drawController.setSelectedPaymentType(selectedPaymentType);
          if (selectedPaymentType === PaymentType.CRYPTO) {
            goToStep('apply');
          } else if (drawController.paymentMethods.length === 0) {
            goToStep('add_payment_method');
          } else {
            goToStep('select_payment_method');
          }
        }}
        variant="primary"
      />
    </div>
  );
};
